import { createReducer, on } from '@ngrx/store';
import { updateRFQSummaryData, updateRoName, updatePeName, updateDocumentStatusId, resetDocument, UpdatePOCreated } from './rfqSummary.action';
import { SourcingOutcomeInformation } from 'src/app/shared/models/app-models/SourcingOutcome.model';

const initialState: SourcingOutcomeInformation = {} as SourcingOutcomeInformation;

export const rfqSummaryReducer = createReducer(
    initialState,

    on(updateRFQSummaryData, (state, { rfqSummary }) => ({
            ...state,
            ...rfqSummary
    })),

    on(updateRoName, (state, { ROName }) => ({
        ...state,
        ROName
    })),

    on(updatePeName, (state, { AssignedPE }) => ({
        ...state,
        AssignedPE
    })),

    on(updateDocumentStatusId, (state, { DocumentStatusId }) => ({
        ...state,
        DocumentStatusId: DocumentStatusId ?? state.DocumentStatusId
    })),

    on(resetDocument, (state) => ({
        ...state,
        rfqSummary: null
    })),

    on(UpdatePOCreated, (state, { arePOCreated }) => ({
        ...state,
        arePOCreated
    })),
);